// extracted by mini-css-extract-plugin
module.exports = {"AddData":"AddData_AddData__3VtgL","Back":"AddData_Back__1OU_3"};